import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {getIgnoredNotifyResponse} from "./get_ignored_notify_response";

export interface ISilentErrorReport {
    error: {name: string; message: string; groupingHash: string};
    context: string;
    metadata: object;
}

/**
 * For `transformErrorResponse` of a request whose failures the page shows itself: every status is marked with `ignoreNotify`,
 * so the RTK middleware never replaces the page with the error view. That also keeps the failure out of Bugsnag - the ones worth knowing about come with a report.
 */
export const getSilentErrorResponse = (response: FetchBaseQueryError, report: ISilentErrorReport | null) => {
    if (report !== null) {
        notifyBugsnag(report.error, report.context, report.metadata);
    }

    return getIgnoredNotifyResponse(response, [response.status]);
};
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {getIgnoredNotifyResponse} from "./get_ignored_notify_response";

export interface ISilentErrorReport {
    error: {name: string; message: string; groupingHash: string};
    context: string;
    metadata: object;
}

/**
 * For `transformErrorResponse` of a request whose failures the page shows itself: every status is marked with `ignoreNotify`,
 * so the RTK middleware never replaces the page with the error view. That also keeps the failure out of Bugsnag - the ones worth knowing about come with a report.
 */
export const getSilentErrorResponse = (response: FetchBaseQueryError, report: ISilentErrorReport | null) => {
    if (report !== null) {
        notifyBugsnag(report.error, report.context, report.metadata);
    }

    return getIgnoredNotifyResponse(response, [response.status]);
};
